import { formatarDataHora, formatarDia } from '@common/i18n/formatosData';
import { useTranslation } from 'react-i18next';
import type { Campanha } from '../types/Campanha';
import type { Progresso } from '../types/Progresso';

/** "{{count}} pessoas · PT 10, EN 2 · de … a …" e quando sincronizou (spec 28 R17; diálogo de abrir). */
export function ResumoAbrir({ campanha, progresso }: { campanha: Campanha; progresso: Progresso }) {
  const { t } = useTranslation(['campanhas', 'participantes']);
  const idiomas = Object.entries(progresso.idiomas)
    .filter(([, n]) => n >= 1)
    .map(([i, n]) => `${i} ${n}`)
    .join(', ');
  return (
    <div className="flex flex-col gap-1 text-sm">
      <p className="font-medium text-foreground" data-resumo-abrir>
        {t('campanhas:resumoAbrir', {
          count: progresso.naCampanha,
          idiomas,
          inicio: formatarDia(campanha.inicio),
          fim: formatarDia(campanha.fim),
        })}
      </p>
      {progresso.sincronizadaEm && (
        <p className="text-foreground-muted">
          {t('participantes:status.sincronizadaEm', {
            quando: formatarDataHora(progresso.sincronizadaEm),
          })}
        </p>
      )}
    </div>
  );
}
